import angular from "angular";
import SquareCard from "./SquareCard.vue";
import Vue from "vue";
import "ngVue";

export default angular
  .module("directives.squarecard", [])
  .directive("dcSquareCard", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(Vue.component("DcSquareCard", SquareCard));
    },
  ]);

